import isGalleryItem from 'src/js/modules/focal-point/helpers/is-gallery-item';
import isPlaceholder from 'src/js/modules/extensions/registry/ws-image/helpers/is-placeholder';

const getMediaContainerData = (mediaElement) => {
  if (!mediaElement) return {};

  return {
    aspectRatio: mediaElement.getAttribute('aspect-ratio'),
    contentPosition: mediaElement.getAttribute('content-position'),
    contentScale: mediaElement.getAttribute('content-scale'),
    mediaGroupId: mediaElement.getAttribute('media-group-id'),
    isPlaceholder: isPlaceholder(mediaElement),
    ...(isGalleryItem(mediaElement)
      ? {
          originSrc: mediaElement.getAttribute('origin-src'),
          originWidth: mediaElement.getAttribute('origin-width'),
          originHeight: mediaElement.getAttribute('origin-height'),
          lightboxDisabled: mediaElement.hasAttribute('lightbox-disabled'),
        }
      : {}),
  };
};

const getImageData = (mediaElement) => {
  const imageElement = mediaElement?.querySelector('img');

  if (!imageElement) return {};

  return {
    src: imageElement.getAttribute('src'),
    alt: imageElement.getAttribute('alt') || '',
    ...(isGalleryItem(mediaElement)
      ? {
          title: imageElement.getAttribute('data-title') || '',
          description: imageElement.getAttribute('data-description') || '',
        }
      : {}),
  };
};

const getIframeData = (mediaElement) => {
  const iframeElement = mediaElement?.querySelector('ws-iframe');

  if (!iframeElement) return {};

  return Object.fromEntries([...iframeElement.attributes].map((attr) => [attr.name, attr.value]));
};

const getDataFromMediaNode = (mediaElement, grouped = false) => {
  const mediaContainerData = getMediaContainerData(mediaElement);
  const iframeData = getIframeData(mediaElement);
  const imageData = getImageData(mediaElement);

  if (grouped) {
    return {
      mediaContainerData,
      imageData,
      iframeData,
    };
  }

  return {
    ...mediaContainerData,
    ...imageData,
    ...iframeData,
  };
};

export default getDataFromMediaNode;
